// Copyright: IQGeo Limited 2010-2019
import _ from 'underscore';
import myw from 'myWorld/base/core';
import $ from 'jquery';
import printHtml from 'text!html/print.html';
import 'myWorld/layouts/layout';
import 'myWorld/base/util';
import 'myWorld/base/viewManager';
import 'myWorld/controls/printOptionsControl';
import L from 'leaflet';
import Promise from 'bluebird';

/**
 * Layout for a print ready map
 */
myw.PrintLayout = myw.Layout.extend({
    options: {
        mapDivId: 'print_map_canvas'
    },

    initialize(owner, options) {
        myw.Layout.prototype.initialize.call(this, owner, options);

        //restore session variables
        try {
            const sessionVars = JSON.parse(localStorage.getItem('sessionVars'));
            if (sessionVars) {
                Object.keys(sessionVars).forEach(key =>
                    this.app.database.setSessionVar(key, sessionVars[key])
                );
            }
        } catch (e) {
            console.log('Reading session variables for print:', e);
        }

        this.template_dir = 'modules/custom/print_templates';
    },

    initUI() {
        //load Html and css
        this.$el.html(printHtml);

        this.setWrapperWidth();

        this.control = new myw.PrintOptionsControl(this.app);

        const control = this.control;

        this.translate(this.$el);

        //only resolve when the template has loaded
        return this.switchTemplate().then(map => {
            control.getPrintElementsFromTemplate();
            return map;
        });
    },

    initControls() {
        //disable selection on the geoMapControl
        this.app.map.endCurrentInteractionMode();
    },

    createContainerForInternals() {
        this.$(`#${this.options.mapDivId}`).append(
            $('<div>', { id: 'view-container-start', class: 'clearit' })
        );
    },

    createContainerForMap() {
        this.$(`#${this.options.mapDivId}`).append(
            "<div id='map-container' class='map-section'></div>"
        );
    },
    /**
     * Switches the current print template to the one selected by the control
     * @return {Promise}           A promise that will be resolved (with the map) once the template switch has completed
     */
    switchTemplate() {
        //make sure the template configuration is loaded before getting the template name
        return this.control.templateConfigLoaded
            .then(() => {
                // Save or Update the preserved field values
                this.control._preserveFieldValues();
                const templateName = this.control.getTemplateName();

                this.$('.right-content').empty();
                return myw.Util.loadInto(`${this.template_dir}/${templateName}`, '.right-content');
            })
            .then(() => {
                this.setWrapperWidth();
                const map = this.createPrintMap();
                this.setCenteredElements();
                this.app.setMap(map);
                this.app.handleLayersFromParam();
                // Remove the leaflet attribution from the map
                map.attributionControl.setPrefix('');

                this.translate(this.$('.right-content'));

                return map;
            });
    },

    /**
     * Creates a map instance on the defined div
     * @return {GeoMapControl}           The map to be displayed and printed
     */
    createPrintMap() {
        // Check if internals view needs to be created
        if (this.app.getUrlParam('internals') !== '') {
            this.createContainerForInternals();
        }
        this.createContainerForMap();
        const map = new this.options.GeoMapControl(this.app, 'map-container');

        L.control.scale().addTo(map);

        map.once('baselayerchange', this.handleBaseMapsLoaded.bind(this, map, null));

        map.layerManager.addCreateLayerHook(layerDef => {
            layerDef.options.unloadInvisibleTiles = true;
        });

        this.app.on('overlays-changed', ev => {
            if (this.app.getUrlParam('layers') === '') map.layerManager.removeAllLayers();
        });

        this.mapViewManager = new myw.ViewManager(2);
        this.mapViewManager.register('map', map, true);
        this.mapViewManager.show('map');

        return map;
    },

    /**
     * Set the unloadInvisibleTiles parameters to true on the basemaps
     */
    handleBaseMapsLoaded(map, basemapName) {
        // set unloadInvisibleTiles option on leaflet basemaps
        // map.baseMaps is an associative array so must use for loop
        for (const baseMapName in map.baseMaps) {
            if (map.baseMaps[baseMapName] instanceof L.TileLayer) {
                map.baseMaps[baseMapName].options.unloadInvisibleTiles = true;
            }
        }
    },
    /**
     * when the map overlay layers are ready, set the unloadInvisibleTiles parameters to true;
     * @param {obj} map
     */
    _setUnloadInvisibleTileProp(map) {
        _.each(map.layerManager.layers, layer => {
            if (layer.leafletLayer) layer.leafletLayer.options.unloadInvisibleTiles = true;
        });
    },

    setWrapperWidth() {
        const leftWidth = $('.left-content').width(),
            rightWidth = $('.right-content').width(),
            mainWidth = leftWidth + rightWidth;

        $('.main-wrapper').width(mainWidth);
    },
    /**
     * center any elemenbts with the center class
     */
    setCenteredElements() {
        let loc;
        let parentWidth;
        let elWidth;
        const that = this;
        const nImages = $('img').length;
        let nImagesLoaded = 0;
        const imagesLoaded = nImages === 0 || Promise.defer();
        console.log(nImages);
        const incImagesLoaded = () => {
            nImagesLoaded += 1;
            if (nImages === nImagesLoaded) imagesLoaded.resolve();
        };

        if ($('.center').length > 0) {
            //make sure images are loaded so we can center them
            $('img')
                .on('load', incImagesLoaded)
                .each(function() {
                    if (this.complete) incImagesLoaded();
                });

            Promise.cast(imagesLoaded).then(() => {
                $('.center').each(function() {
                    parentWidth = $(this)
                        .parent()
                        .width();
                    elWidth = $(this).width();

                    if (parentWidth === 0 || elWidth === 0) {
                        return true;
                    } else {
                        loc = that.getElLocation(parentWidth, elWidth);
                        $(this).css('left', loc);
                    }
                });
            });
        }
    },
    /**
     * get the location to set a centered element
     * @param  {number} parentWidth
     * @param  {number} elWidth
     * @return {number} number in pixels
     */
    getElLocation(parentWidth, elWidth) {
        parentWidth = parentWidth / 2;
        elWidth = elWidth / 2;

        return parentWidth - elWidth;
    },

    /**
     * Aplies the provided text to the appropriate span
     */
    setText(id, text) {
        $(`#${id}`)
            .children('pre')
            .text(text);
        // ENH: This method call isn't really needed, the element can be centered using CSS.
        this.setCenteredElements();
    }
});

export default myw.PrintLayout;
